import axios from 'axios';
import { logger } from '../../lib/logger';
import {CacheTypes, getCache, putCache} from './cacheUtil';
import {Api_Translate} from "../api";
import {GoogleTokenUtil} from "./google_token_util";
import {getWebhookUrl} from "./runtimeConfig";

enum TranslateLevel {
  low,
  heigh
}

export async function translate(text: string, lang: string, level: TranslateLevel): Promise<string> {
  const freeCountKey = `translateFreeCount-${level}`;
  const freeLengthKey = `translateFreeLength-${level}`;
  const errorCountKey = `translateFreeErrorCount-${level}`;
  const ggCountKey = `translateCount-${level}`;
  const ggLengthKey = `translateLength-${level}`;
  if (GoogleTokenUtil.checkCanUse()){
    let result = await GoogleTokenUtil.translateGoogle(lang,text);
    const count = await getCache(freeCountKey, CacheTypes.CONFIG);
    const length = await getCache(freeLengthKey, CacheTypes.CONFIG);
    let  tempCount = 1;
    let  tempLength = text.length;
    if (count != null){
      tempCount += count;
    }
    if (length != null){
      tempLength += length;
    }
    await putCache(freeCountKey,CacheTypes.CONFIG,tempCount);
    await putCache(freeLengthKey,CacheTypes.CONFIG,tempLength);
    if (result.length > 0){
      return Promise.resolve(result);
    }else {
      const errorCount = await getCache(errorCountKey, CacheTypes.CONFIG);
      let  tempErrorCount = 1;
      if (errorCount != null){
        tempErrorCount += errorCount;
      }
      await putCache(errorCountKey,CacheTypes.CONFIG,tempErrorCount);
    }
  }
  const count = await getCache(ggCountKey, CacheTypes.CONFIG);
  const length = await getCache(ggLengthKey, CacheTypes.CONFIG);
  let  tempCount = 1;
  let  tempLength = text.length;
  if (count != null){
    tempCount += count;
  }
  if (length != null){
    tempLength += length;
  }
  await putCache(ggCountKey,CacheTypes.CONFIG,tempCount);
  await putCache(ggLengthKey,CacheTypes.CONFIG,tempLength);
  return translateWithAI(text, lang);
  // if (level == TranslateLevel.heigh) {
  //   return translateWithGoogle(text, lang);
  // } else {
  //   return translateWithNLLB(text, lang);
  // }
}

async function translateWithGoogle(text: string, lang: string): Promise<string> {
  console.log(`Translate with google lang: ${lang}, text: `, text);
  if (text == null || text == undefined || text.trim().length <= 0) return Promise.resolve('');
  // let rsp = await Api_Translate({'lan':lang,'text':text});
  let rsp = await instance.get(
    'https://translation.googleapis.com/language/translate/v2',
    {
      params: {
        'q': text,
        'target': lang,
        'key': 'AIzaSyDaNB7mShi3e2ZM63mERjCK2Bs2tP-XbA0',
        'format': 'text'
      },
    }).catch((e) => {});
  if (rsp && rsp.status == 200) {
    return Promise.resolve(rsp.data.data['translations'][0]['translatedText']);
    // return Promise.resolve(rsp.data);
  } else {
    return Promise.resolve('');
  }
}

/**
 * 走自有接口翻译（`GET /v1/translate/tr?lan=&text=`，见 docs/api）。
 *
 * 注意响应形状：共享 request 实例只做 status 校验、把响应体原样 resolve，
 * 所以拿到的是**信封**，译文在 `rsp.data`。n8n 那条是 `rsp.data.data`，
 * 两者别写混——这是替换接口时最容易错的一处。
 */
async function translateViaApi(text: string, lang: string): Promise<string> {
  const rsp: any = await Api_Translate({ lan: lang, text });
  if (rsp && rsp.code == 200 && typeof rsp.data === 'string') return rsp.data;
  return '';
}

/**
 * 走 n8n webhook 翻译（旧链路，作为自有接口不可用时的回退）。
 * 地址由外部注入，未注入时用内置默认值（见 utils/runtimeConfig.ts）。
 */
async function translateViaWebhook(text: string, lang: string): Promise<string> {
  const rsp = await instance
    .get(getWebhookUrl('translate'), {
      params: {
        'q': text,
        'target': lang,
        'from': 'tg'
      },
    })
    .catch(() => null);
  if (rsp && rsp.status == 200 && rsp.data && typeof rsp.data.data === 'string') {
    return rsp.data.data;
  }
  return '';
}

/**
 * 翻译入口：**优先自有接口，失败回退 webhook**。
 *
 * 为什么保留回退：自有接口在 api.dmex.io 上**无法提前验证**——网关在路由之前
 * 就做鉴权，401/402 不携带任何"路由是否存在"的信息（探测已证：不存在的路径
 * 与真实路径返回完全相同的响应），而 webhook 是当前在用的链路。等新域名上
 * 确认了接口可用，就可以把回退摘掉。
 *
 * 两条都失败返回空串：调用方（translateReceive / translateSend）对空串的处理
 * 是"不翻译"，不会把异常内容当成译文展示出去。
 *
 * 另：会话过期（code 402）时共享实例会顺带弹「加入工作组」卡片，这里拿不到
 * 200 于是回退 webhook；webhook 不需要鉴权所以仍可能译出结果。这是刻意的——
 * 卡片负责提示需要重新绑定，翻译能继续属于附带好处。
 */
async function translateWithAI(text: string, lang: string): Promise<string> {
  if (text == null || text == undefined || text.trim().length <= 0) return Promise.resolve('');
  try {
    const viaApi = await translateViaApi(text, lang);
    if (viaApi) return viaApi;
  } catch (error) {
    console.warn('Translate via api failed, fallback to webhook:', error);
  }
  return translateViaWebhook(text, lang);
}

async function translateWithNLLB(text: string, lang: string): Promise<string> {
  if (text.trim().length <= 0) return Promise.resolve('');
  let rsp = await instance.get(
    'https://test-im.yay.chat/translate_api/translate',
    {
      params: {
        'text': text,
        'lang': lang
      },
    }).catch((e) => {});
    console.log('Result from nllb is: ', rsp);
  if (rsp && rsp.status == 200) {
    return Promise.resolve(rsp.data);
  } else {
    return Promise.resolve('');
  }
}


// translate the message will send
export async function translateSend(
  text: string, lang: string
  ): Promise<string> {
    if (!getTranslateSendSwitch()) return Promise.resolve('');

    const result = await translate(text, lang,  TranslateLevel.heigh);

    return Promise.resolve(result);
}

// translate the message received
export async function translateReceive(
  peerId: number, msgId: number, text: string, isSend: boolean
  ): Promise<string> {
    if (!getTranslateReceiveSwitch()) return Promise.resolve('');

    const lang = isSend ? getTargetLang(peerId) : getMyLang();

    const result = await translate(text, lang, TranslateLevel.low);

    logger(`Translated text with msgId: ${msgId}, lang: ${lang}, text: ${text}, result: ${result}`);

    return Promise.resolve(result);
}

export function getTranslateReceiveSwitch(): boolean {
  return '1' === localStorage.getItem('translate-receive');
}

export function getTranslateSendSwitch(): boolean {
  return '1' === localStorage.getItem('translate-send');
}

export function getTargetLang(peerId: number): string {
  const lang = localStorage.getItem(`${peerId}-translate-lang`);
  if (lang == null || lang.length == 0) return 'en';
  return lang;
}

export function getMyLang(): string {
  return 'zh';
}


// 创建axios的对象
const instance = axios.create({
  // baseURL: import.meta.env.VITE_BASE_URL, //配置固定域名
  // baseURL: "", //配置固定域名
  timeout: 10000
});

instance.interceptors.request.use(
  function (config) {
    config.headers["Content-Type"] = "application/json;charset=utf-8;";
    return config;
  },
  function (err) {
    return Promise.resolve(err);
  }
);
